import React from 'react';
import { func } from 'prop-types';
import Modal from '@active/react-ui/Modal';
import ModalBody from '@active/react-ui/ModalBody';
import ModalFooter from '@active/react-ui/ModalFooter';
import Button from '@active/react-ui/Button';
import { Locale, useLocale } from '@active/react-utils/i18n';

const CheckEndorseModal = ({
  handleCheckEndorseModalClose,
  handleCheckEndorse,
}) => {
  const { i18n } = useLocale();
  return (
    <Modal
      className="check-endorse-modal"
      title={i18n('checkout.lib.components.payment.check.endorseModal.title')}
      shown={true}
      style={{ margin: 'auto' }}
      onClose={handleCheckEndorseModalClose}
      size='small'
      autoFocusClose={false}>
      <ModalBody>
        <Locale id="checkout.lib.components.payment.check.endorseModal.body"/>
      </ModalBody>
      <ModalFooter className='modal-footer endorse-btn-container'>
        <Button
          type="secondary"
          className="cancel-btn"
          onClick={handleCheckEndorseModalClose}>
          <Locale id="checkout.lib.components.common.btn.cancel"/>
        </Button>
        <div>
          <Button
            type="secondary"
            className="skip-btn"
            onClick={() => handleCheckEndorse(false)}>
            <Locale id="checkout.lib.components.common.btn.skip"/>
          </Button>
          <Button
            style={{ marginLeft: '20px' }}
            className="endorse-btn"
            onClick={() => handleCheckEndorse(true)}>
            <Locale id="checkout.lib.components.common.btn.endorse"/>
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

CheckEndorseModal.propTypes = {
  handleCheckEndorseModalClose: func.isRequired,
  handleCheckEndorse: func.isRequired,
};

export default CheckEndorseModal;
